import { clearStore } from '@app/core/authentication/store/auth/auth.actions';
import { IStoreState } from '@app/core/store/store-core.interface';
import { Action, ActionReducer } from '@ngrx/store';

export function logoutMetaReducer(reducer: ActionReducer<IStoreState>): ActionReducer<IStoreState> {
  return (state: IStoreState | undefined, action: Action) => {
    /**
     * @description `{ auth: { ...(state?.['auth'] || {}) }, appContext: { ...(state?.['appContext'] || {}) } }` for saving auth and appContext state if not needed then change to `{}`
     */
    return reducer(
      action.type === clearStore.type
        ? { auth: { ...(state?.['auth'] || {}) }, appContext: { ...(state?.['appContext'] || {}) } }
        : state,
      action
    );
  };
}
